module.exports = __webpack_public_path__ + "static/media/Growlithe_gaussian2.43b133cc.png";